import { render, staticRenderFns } from "./DialogQuestionHistoryItems.vue?vue&type=template&id=1831d12a&scoped=true"
import script from "./DialogQuestionHistoryItems.vue?vue&type=script&lang=js"
export * from "./DialogQuestionHistoryItems.vue?vue&type=script&lang=js"
import style0 from "./DialogQuestionHistoryItems.vue?vue&type=style&index=0&id=1831d12a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831d12a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1831d12a')) {
      api.createRecord('1831d12a', component.options)
    } else {
      api.reload('1831d12a', component.options)
    }
    module.hot.accept("./DialogQuestionHistoryItems.vue?vue&type=template&id=1831d12a&scoped=true", function () {
      api.rerender('1831d12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogQuestionHistoryItems.vue"
export default component.exports